const BASE = process.env.PUBLIC_URL;

// Every gallery original is 2048x1365.
const ORIGINAL = { width: 2048, height: 1365 };

// Widths produced by `npm run images` (scripts/generate-image-sizes.js) and
// committed next to the originals. Heights are what sharp actually wrote
// rather than the exact ratio, so the album lays out on real dimensions.
const DERIVATIVES = [
  { width: 640, height: 426 },
  { width: 1024, height: 683 },
  { width: 1600, height: 1066 },
];

/**
 * The grid renders these around 675px wide, so the browser picks a derivative
 * from the srcSet. `src` stays the full-resolution original, which is what the
 * lightbox opens.
 */
const photo = (id, ext) => {
  const stem = `${BASE}/real_images/${id}`;
  const original = { src: `${stem}.${ext}`, ...ORIGINAL };

  return {
    id: String(id),
    ...original,
    alt: 'The Boombox Miami',
    srcSet: [
      ...DERIVATIVES.map(({ width, height }) => ({
        src: `${stem}-${width}w.jpg`,
        width,
        height,
      })),
      original,
    ],
  };
};

export const galleryImages = [
  photo(1, 'jpeg'),
  photo(2, 'jpeg'),
  photo(3, 'jpeg'),
  photo(4, 'jpeg'),
  photo(5, 'jpeg'),
  photo(6, 'jpeg'),
  photo(7, 'jpeg'),
  photo(8, 'jpg'),
  photo(9, 'jpg'),
  photo(10, 'jpg'),
  photo(11, 'jpg'),
  photo(12, 'jpg'),
  photo(13, 'jpg'),
];
